import { InlineBanner } from "@safetyculture/sc-web-ui";
import * as React from "react";
import { useFlag } from "../../../config/featureFlags";

const BANNER_TEXT = ""; // Control banner's text by code. Banner is hidden when text is empty.

type BannerProps = {
  is_enabled_override?: boolean;
};

/**
 * ON/OFF toggle  Powered by unleash operational flag
 * PROD:          https://unleash.syd.internal.safetyculture.com/projects/default/features/portal.maintenance_banner_enabled
 * DEV/SANDPIT:   https://unleash.us.sandpit-internal.safetyculture.com/projects/default/features/portal.maintenance_banner_enabled
 */
export const MaintenanceInfoBanner: React.FC<BannerProps> = ({
  is_enabled_override = false,
}) => {
  const { isVisible, setIsVisible } = React.useContext(
    MaintenanceBannerContext,
  );
  React.useEffect(() => {
    if (is_enabled_override) {
      setIsVisible(is_enabled_override);
    }
  }, [is_enabled_override, setIsVisible]);

  return (
    (!!BANNER_TEXT && isVisible && (
      <div style={{ marginBottom: 24 }} data-testid="maintenance-banner">
        <InlineBanner
          status="warning"
          closeProps={{
            onClick: () => setIsVisible(false),
          }}
        >
          {BANNER_TEXT}
        </InlineBanner>
      </div>
    )) ||
    null
  );
};

/**
 * Context allows us to hide the banner for the session wherever it is used in the code
 */
export const MaintenanceBannerContext = React.createContext<{
  isVisible: boolean;
  setIsVisible: (is_visible: boolean) => void;
}>({
  isVisible: false,
  setIsVisible: () => {},
});

export const MaintenanceInfoBannerProvider: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const is_enabled = useFlag("portal.maintenance_banner_enabled");
  const [isVisible, setIsVisible] = React.useState(false);

  React.useEffect(() => {
    if (is_enabled) {
      setIsVisible(is_enabled);
    }
  }, [is_enabled]);

  return (
    <MaintenanceBannerContext.Provider
      value={{
        isVisible,
        setIsVisible,
      }}
    >
      {children}
    </MaintenanceBannerContext.Provider>
  );
};
